module.exports = __webpack_public_path__ + "static/media/background.b805bc2b.jpeg";